// TODO [refactor] see GuestPurchaseItemPage.js, PurchaseInstalmentPage.js

import { useState, useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { getPaymentInfoMemberAction } from '../../actions/paymentInfoActions'
import {
  checkoutTapPayAction,
  loadTapPaySDKAction,
} from '../../actions/tapPayActions'
import { getTimezone } from '../../libs/dates'
import {
  formatNumber,
  remove886,
  toSegmentedPhoneNumber,
} from '../../libs/utils'
import {
  isPeriodicPaymentSelector,
  isDiscountEnabledSelector,
  isDiscountOnlySelector,
} from '../../reducers/itemEntryReducer'
import BottomSheet from '../babu/BottomSheet'
import BulletButton from '../babu/BulletButton'
import SwitchButton from '../babu/SwitchButton'
import TableRow from '../babu/TableRow'
import BottomButtonArea from '../common/BottomButtonArea'
import ItemQuantitySelect from '../common/ItemQuantitySelect'
import NavBar from '../common/NavBar'
import { ga4Event } from '../libs/ga4'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'
import useItemQuantity from '../libs/hooks/useItemQuantity'
import { purchaseResultSelector } from '../libs/selectors'
import TapPayPaymentPage from '../tappay/TapPayPaymentPage'
import AgreeTermsCard from './AgreeTermsCard'
import ConfirmPurchaseTopArea from './ConfirmPurchaseTopArea'
import FetchPaymentInfo from './FetchPaymentInfo'
import SelectPaymentCard from './SelectPaymentCard'

/*
  paymentInfo: {
      "title": "團購名稱",
      "contact": "+886912345678",
      "payment_amount": 335,  // 不分期/首期應付金額 (台幣)
      "cash_discount": 120,   // "Slash收款"折抵金額 (Slash收款+Slash回饋=Slash折抵金額)
      "reward_discount": 160, // "Slash回饋"折抵金額 (Slash收款+Slash回饋=Slash折抵金額)
      "token_discount": 35,   // "我的回饋"折抵金額
      "deposit_amount": 20,   // 不分期/首期實付金額 (台幣)
      "exchange_rate": 31,    // 台幣兌美元匯率
      "status": "created"     // created (開放中); terminated (已停止收款); filled (已額滿); expired (已結束)
  }
 */

/*
  props: paymentInfo, memberId, itemId, loadSDK, checkoutTapPay, isInstalment, vendorInfo
 */
function MemberPurchaseItem(props) {
  const [useToken, setUseToken] = useState(false)
  const [openTokenModal, setOpenTokenModal] = useState(false)
  const [openTapPay, setOpenTapPay] = useState(false)
  const [agreed, setAgreed] = useState(false)

  const {
    checkoutTapPay,
    isPeriodicPayment,
    isDiscountEnabled,
    isDiscountOnly,
    itemId,
    memberId,
    username,
    paymentInfo,
    vendorInfo,
    stayAtPurchase,
  } = props

  const {
    instalment,
    price: pricePerQty,
    max_qty: maxQuantity,
    payment_amount: paymentAmount,
    exchange_rate: exchangeRate,
    cash_discount: cashDiscount, // "Slash收款"折抵金額
    reward_discount: rewardDiscount, // "Slash回饋"折抵金額
    // disposable_amount: disposableAmount, // 可動用的Slash餘額
    disposable_tokens: disposableTokens, // 現有的回饋餘額
    token_discount: tokenDiscount, // "我的回饋"折抵金額
    // deposit_amount: depositAmount, // 不分期/首期實付金額 (台幣)
    disposable_product_cash: disposableProductCash, // 可動用之 Slash 現金收款金額
    disposable_product_reward: disposableProductReward, // 可動用之 Slash 回饋收款金額
  } = paymentInfo

  const { quantity, setQuantity, quantityFixed } = useItemQuantity(maxQuantity)

  const isInstalment = instalment > 1

  const quantitySelectable = isInstalment ? false : maxQuantity > 1

  const amountBeforeDiscount = quantitySelectable
    ? quantity * pricePerQty
    : paymentAmount

  const usedCashDiscount = useToken
    ? quantitySelectable
      ? Math.min(amountBeforeDiscount, disposableProductCash)
      : cashDiscount
    : 0
  const usedRewardDiscount = useToken
    ? quantitySelectable
      ? Math.min(
          amountBeforeDiscount - usedCashDiscount,
          disposableProductReward,
        )
      : rewardDiscount
    : 0
  const usedTokenDiscount = useToken
    ? quantitySelectable
      ? Math.min(
          amountBeforeDiscount - usedCashDiscount - usedRewardDiscount,
          disposableTokens,
        )
      : tokenDiscount
    : 0
  const amount =
    amountBeforeDiscount -
    usedCashDiscount -
    usedRewardDiscount -
    usedTokenDiscount

  const checkoutButtonCallback = useCallback(() => {
    if (!agreed) return
    if (amount === 0) {
      ga4Event('slash_checkout_pay_0')
    }
    if (useToken) {
      setOpenTokenModal(true)
    } else {
      setOpenTapPay(true)
    }
  }, [agreed, useToken, setOpenTokenModal, setOpenTapPay, amount])

  const checkoutTapPayCallback = useCallback(
    skipTapPay => {
      checkoutTapPay(
        memberId,
        itemId,
        skipTapPay,
        usedCashDiscount,
        usedRewardDiscount,
        usedTokenDiscount,
        quantity,
        maxQuantity,
      )
    },
    [
      checkoutTapPay,
      itemId,
      memberId,
      usedCashDiscount,
      usedRewardDiscount,
      usedTokenDiscount,
      quantity,
      maxQuantity,
    ],
  )

  const onConfirmTokenModalCallback = useCallback(() => {
    setOpenTokenModal(false)
    if (amount === 0 && !isInstalment && !isPeriodicPayment) {
      // * 不分期一次付清（全額折抵）、不是定期定額，不需刷卡
      checkoutTapPayCallback(true)
    } else {
      setOpenTapPay(true)
    }
  }, [
    amount,
    checkoutTapPayCallback,
    isInstalment,
    isPeriodicPayment,
    setOpenTapPay,
    setOpenTokenModal,
  ])

  useEffect(() => {
    if (stayAtPurchase) {
      setOpenTapPay(false)
    }
  }, [stayAtPurchase, setOpenTapPay])

  useGA4Pageview('slash_checkout_both', !isDiscountOnly && isDiscountEnabled)
  useGA4Pageview('slash_checkout_redeem', isDiscountOnly)
  useGA4Pageview('slash_checkout_creditcard', !isDiscountEnabled)

  if (openTapPay) {
    return (
      <TapPayPaymentPage
        price={amount}
        onCancel={() => setOpenTapPay(false)}
        onCheckout={() => checkoutTapPayCallback(false)}
        loadSDK={() => props.loadSDK(itemId)}
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    )
  }

  return (
    <>
      <NavBar />
      <BottomButtonArea
        variant="solid"
        disabled={
          !agreed ||
          (isDiscountOnly && !useToken) ||
          (isDiscountOnly && amount > 0)
        }
        onClick={checkoutButtonCallback}>
        {`支付 NT$${formatNumber(amount)}`}
      </BottomButtonArea>
      <ConfirmPurchaseTopArea
        phone={username}
        amount={amount}
        amountUSD={amount / exchangeRate}
      />
      <div className="container px-xs">
        <h4 className="babu-text-paragraph-bold text-text600 mx-m my-xs">
          訂單資訊
        </h4>
        {vendorInfo ? (
          <TableRow
            content="收款商家"
            accessoryLabel={vendorInfo.name}
            divided
          />
        ) : (
          <TableRow
            content="賣家手機"
            accessoryLabel={toSegmentedPhoneNumber(
              remove886(paymentInfo.contact),
            )}
            divided
          />
        )}
        <TableRow content="名稱" accessoryLabel={paymentInfo.title} divided />
        <TableRow
          content="單價"
          accessoryLabel={`NT$${formatNumber(pricePerQty)}`}
          divided
        />
        {quantitySelectable ? (
          <TableRow
            content="數量"
            accessory={
              <ItemQuantitySelect
                maxQuantity={maxQuantity}
                quantity={quantity}
                setQuantity={setQuantity}
                quantityFixed={quantityFixed}
              />
            }
            divided
          />
        ) : null}
      </div>
      <div className="container mt-l mb-30">
        {isDiscountEnabled ? (
          // Slash 餘額: disposableAmount - usedCashDiscount - usedRewardDiscount
          <div className="babu-card px-0 pb-s">
            <header className="babu-text-button-bold mx-m">使用回饋折抵</header>
            <TableRow
              divided={false}
              content={`回饋餘額 $${formatNumber(
                disposableTokens - usedTokenDiscount,
              )}`}
              accessory={
                <div className="text-right flex flex-nowrap">
                  {useToken ? (
                    <span className="text-primary mr-xxs">{`-$${formatNumber(
                      usedTokenDiscount,
                    )}`}</span>
                  ) : null}
                  <SwitchButton
                    checked={useToken}
                    // * SWA=390
                    // disabled={
                    //   tokenDiscount + cashDiscount + rewardDiscount === 0
                    // }
                    onChange={() => setUseToken(!useToken)}
                  />
                </div>
              }
            />
            {usedCashDiscount + usedRewardDiscount > 0 ? (
              <p className="mx-m my-xs">
                使用 Slash 折抵金額{' '}
                <span className="text-primary">{`-$${formatNumber(
                  usedCashDiscount + usedRewardDiscount,
                )}`}</span>
              </p>
            ) : null}
            {isDiscountOnly && useToken && amount > 0 ? (
              <p className="text-right text-alert-danger mx-m">回饋餘額不足</p>
            ) : null}
          </div>
        ) : null}
        {isDiscountOnly ? null : <SelectPaymentCard cardClassName="mt-m" />}
        <AgreeTermsCard
          agreed={agreed}
          setAgreed={setAgreed}
          cardClassName="mt-m"
        />
      </div>
      {/* {isDiscountOnly && quantitySelectable ? null : (
          <>
            <ItemDetailRow
              label="應付金額（元）"
              type="price"
              value={amountBeforeDiscount}
            />
            <ItemDividerRow />
          </>
        )} */}
      {/* {isDiscountOnly && !quantitySelectable ? null : (
          <>
            <ItemDividerRow />
            <Grid.Row className="item-detail-description-grid">
              <Grid.Column width={7}>實付金額（元）</Grid.Column>
              <Grid.Column className="right-column" width={9}>
                {formatItemDetailValue('price', amount)}
                {amount >= 0 ? (
                  <div className="remark">
                    {`約等於美金 ${formatNumber(roundPrecision(amount / exchangeRate))} 元`}
                  </div>
                ) : null}
              </Grid.Column>
            </Grid.Row>
          </>
        )} */}
      <BottomSheet open={openTokenModal} setOpen={setOpenTokenModal}>
        <div className="container pt-m pb-xl">
          <p className="babu-text mb-m">
            {isPeriodicPayment
              ? '定期定額訂單需要綁定信用卡，確定使用 aifian 回饋折抵付款並綁定信用卡嗎？'
              : '確定使用 aifian 回饋折抵付款嗎？'}
          </p>
          <BulletButton
            variant="solid"
            onClick={onConfirmTokenModalCallback}
            className="mb-m">
            確定
          </BulletButton>
          <BulletButton
            variant="light"
            onClick={() => setOpenTokenModal(false)}>
            取消
          </BulletButton>
        </div>
      </BottomSheet>
    </>
  )
}

const ConnectedMemberPurchaseItem = connect(
  state => ({
    memberId: state.user.member_id,
    paymentInfo: state.buyer.paymentInfo,
    vendorInfo: state.vendor.vendorInfo,
    username: state.user.username,
    isPeriodicPayment: isPeriodicPaymentSelector(state.itemEntry),
    isDiscountEnabled: isDiscountEnabledSelector(state.itemEntry),
    isDiscountOnly: isDiscountOnlySelector(state.itemEntry),
    stayAtPurchase: purchaseResultSelector(state.tapPay)?.stayAtPurchase,
  }),
  dispatch => ({
    checkoutTapPay(
      memberId,
      itemId,
      skipTapPay,
      cashDiscount,
      rewardDiscount,
      tokenDiscount,
      qty,
      maxQuantity,
    ) {
      dispatch(
        checkoutTapPayAction({
          qty,
          skipTapPay,
          maxQuantity,
          member_id: memberId,
          cream_item_id: itemId,
          timezone: getTimezone(),
          cash_discount: cashDiscount,
          reward_discount: rewardDiscount,
          token_discount: tokenDiscount,
        }),
      )
    },
    loadSDK(itemId) {
      dispatch(loadTapPaySDKAction({ itemId }))
    },
    fetchPaymentInfo(itemId) {
      dispatch(getPaymentInfoMemberAction(itemId))
    },
  }),
)(MemberPurchaseItem)

export default function MemberPurchaseItemPage(props) {
  return (
    <FetchPaymentInfo itemId={props.itemId}>
      <ConnectedMemberPurchaseItem
        toPurchaseLoginPage={props.toPurchaseLoginPage}
      />
    </FetchPaymentInfo>
  )
}
